import _extends from "@swc/helpers/src/_extends.mjs";
// DS: I43
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const Page = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(5 2)",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "14",
        height: "20",
        rx: "1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11 0h2a1 1 0 0 1 1 1v2h-3V0z",
        fill: "transparent"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.5 12.5h9M2.5 10.5h9M2.5 14.5h9M2.5 16.5h4",
        stroke: "#DADADA",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))));
Page.displayName = 'Page';
export default Page;
